// src/polaris-components/SubscriptionSuccess.tsx
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import '../styles/subscription-success.css';
import "../styles/login-page.css";
import polarisLogoLight from "../images/Polaris Logo.svg";
import polarisLogoDark from "../images/Polaris Logo Dark.svg";

export const SubscriptionSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="subscription-success-page" data-testid="subscription-success">
      <header className="success-header">
        <div className="header-content">
          <div className="subscription-success-logo">
              <img
                  src={polarisLogoLight}
                  alt="Polaris Athlete"
              />
          </div>
          <div className="sign-in-link">
            Already have an account? <a href="/login">Sign In</a>
          </div>
        </div>
      </header>

      <main className="success-main">
        <div className="success-content">
          <div className="content-logo">
            <img
              src={polarisLogoDark}
              alt="Polaris Athlete"
            />
          </div>

          <h1 className="success-title">Success you're now subscribed to Polaris Athlete!</h1>

          <div className="success-body">
            <p className="intro-text">
              Thank you for joining Polaris Athlete, the platform built for student-athletes, powered and certified through Polaris Athlete LLC.
            </p>

            <p className="access-text">
              You can access the platform anytime at <a href="https://polarisathletehub.com" className="hub-link" target="_blank" rel="noopener noreferrer">polarisathletehub.com</a>
            </p>

            <p className="email-text">
              You'll receive a welcome email shortly with a secure link to set up your password.
            </p>

            <div className="next-steps">
              <h3>What's Next</h3>
              <ol>
                <li>Check your email for your Polaris Athlete login link. If you don't see it, check spam and add Polaris Athlete to your trusted senders for future updates.</li>
                <li>Sign in using your email and password</li>
                <li>Log in and start exploring</li>
              </ol>
            </div>

            <p className="closing-text">
              Welcome to the Polaris community. We're excited to support your journey. If you have any questions reach out to <a href="mailto:support@polarisathlete.com" className="support-link">support@polarisathlete.com.</a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};
